import React, { useState, useCallback, useEffect, useContext } from 'react';
import styled/*, { css }*/ from 'styled-components';
import { Buttons, HeaderContainer, ValidationAlert } from '../../style';
import { SmallInput, PageHeader, Button, Content } from 'scorer-ui-kit';
import { useTranslation } from 'react-i18next';
import { MenuContext, PathContext } from '../../App';
import useLocalStorage from '../../hooks/useLocalstorage';

const Container = styled(Content) <{ marginLeft?: string }>`
  display: flex;
  flex: 1;
  margin-left: ${({ marginLeft }) => marginLeft ? marginLeft : '295px'};
  
  //height: auto;  
  //width: 700px;
  height: 100%;
  width: 100%;
  max-width: 700px;
  flex-direction: column;
  padding: 67px 50px 25px 45px;
  transition: 0.2s;
  //overflow: initial;
  /*& > div {
    max-width: auto;
  }*/
`;

const StartTypeContainer = styled.div`
  display: flex;
  width: inherit;
  margin: 5px 0 0 0;
  height: 400px;
`;

const Position = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 0 0 10px 0;
`;

const DelButton = styled(Button)`
  margin-top: 5px;
  //margin-bottom: 20px;
`;

const SmallInputContainer = styled.div`
  display: flex;
  width: auto;
  margin: 0 5px 0 0; 
`;

const SmallInputBox = styled(SmallInput)`
  width: 200px;
  padding: 0 14px 0 0;
  border-radius: 3px;
  outline: none;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 12px;
  color: #767676;
  margin-top: -5px;
  
  margin-bottom: -20px;
`;

const InputHeader = styled.label`
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.35px;
  color: #7f7f7f;
  margin-bottom: 7px;
`;

const InputField = styled.div`
  display: flex;
  flex-direction: column;
`;
/*
const FieldLabel = styled(Label)`
  height: 10px;
  margin: 2px 0 8px 2px;
  font-size: 12px;
  color: #767676;
  white-space: nowrap;
`;*/

const PlaceCameras = () => {
  const { t } = useTranslation(['SetupCameras', 'Common']);
  const [validationAlert, setValidationAlert] = useState<{ key?: any, message: string, type: 'success' | 'error' | 'warning' | 'info' | undefined }>({ key: new Date(), message: '', type: undefined });

  const { completedStep, setSelectedStep, setCompletedStep} = useContext(MenuContext);
  const { pathUpdated } = useContext(PathContext);

  const { floorPlanStorage, setFloorPlanStorage } = useLocalStorage();
  const [ operators, setOperators ] = useState(floorPlanStorage.operators ? floorPlanStorage.operators : []);

  const [ maxOperatorID, setMaxOperatorID ] = useState(floorPlanStorage.maxOperatorID ? floorPlanStorage.maxOperatorID : 0);


  //オペレーター追加
  const addOperator = useCallback(() => {
    const newOperators = {'id': maxOperatorID + 1, 'name': 'OperatorName' + (maxOperatorID + 1)};

    //nameに重複しているかどうかチェック
    const nameList = [];
    for(let i = 0; i < operators.length; i++) {//既存name取得
      nameList.push(operators[i].name);
    }
    if (nameList.indexOf(newOperators.name) !== -1){
      newOperators.name = '_OperatorName' + (maxOperatorID + 1);
    }

    setOperators([...operators, newOperators]);
    setMaxOperatorID(maxOperatorID + 1);
  }, [maxOperatorID, operators]);

  //オペレーター削除
  const delOperator = useCallback((selectedID) => {
    if (operators.length === 1) {
      return false;
    }
    
    const newOperators = [...operators];
    for(let i = 0; i < newOperators.length; i++) {
      if (newOperators[i].id === selectedID){
        newOperators.splice(i, 1);
        break;
      }
    }
    setOperators(newOperators);
  }, [operators]);

  //ジョブ名変更
  const renameOperator = useCallback((ev, selectedID) => {
    const newOperators = [...operators];

    //同名判定
    for(let i = 0; i < newOperators.length; i++){
      if(newOperators[i].name === ev.target.value && newOperators[i].id !== selectedID) {
        setValidationAlert({ key: new Date(), message: '同名のオペレーターが存在しております。オペレーター名：' + ev.target.value, type: 'error' });
        return;
      }
    }

    for(let i = 0; i < newOperators.length; i++) {
      if (newOperators[i].id === selectedID){
        newOperators[i].name = ev.target.value;
        break;
      }
    }
    setOperators(newOperators);
  }, [operators]);


  /*---------route---------*/
  const onContinue = useCallback((index: number) => {
    setFloorPlanStorage({operators});
    setFloorPlanStorage({maxOperatorID});
    setSelectedStep(index);
    setCompletedStep(completedStep > 10 ? completedStep : 10);
  }, [maxOperatorID, operators, completedStep, setCompletedStep, setSelectedStep, setFloorPlanStorage]);

  useEffect(() => {
    if (pathUpdated) { setSelectedStep(10); }
  }, [setSelectedStep, pathUpdated]);
  /*---------route---------*/
  return (
    <Container>
      <HeaderContainer>
        <PageHeader title='オペレーター設定' areaHref='/' areaTitle={floorPlanStorage.completed_step === 999 ? '初期設定': '設定編集'} />
        <Buttons>
          <Button design='primary' size='small' onClick={() => onContinue(11)}>{t('Common:next')}</Button>
        </Buttons>
      </HeaderContainer>

      {validationAlert.message !== '' &&
        <ValidationAlert type={validationAlert.type} message={validationAlert.message} />}

      {/* start type 設定*/}
      <StartTypeContainer>
        <Position>
          <InputHeader>オペレーター名</InputHeader>
          <SmallInputContainer>
            <InputField>
              {operators.map((operator: any)=>{
                return <SmallInputBox key={operator.id} label='' defaultValue={operator.name} onChange={(event) => renameOperator(event, operator.id)} />;
              })}
            </InputField>
          </SmallInputContainer>
        </Position>

        <Position>
          <InputHeader>操作</InputHeader>
          {operators.map((operator: any)=>{
            return (
              <SmallInputContainer key={'del_'+operator.id}>
                <InputField>
                  <DelButton key={'delbtn_'+operator.id} size='small' design='primary' onClick={() => delOperator(operator.id)}>削除</DelButton>
                </InputField>
              </SmallInputContainer>);
          })}
          <SmallInputContainer>
            <InputField>
              <DelButton size='small' design='primary' onClick={addOperator}>追加</DelButton>
            </InputField>
          </SmallInputContainer>
        </Position>
      </StartTypeContainer>

    </Container>
  );
};

export default PlaceCameras;
